import {DocGetListItem} from "../../../../../interfaces/ecom/schema";

export const isTDSDocType = (downloads: DocGetListItem[]) => {
    return downloads.some(({DocTypeLabel}) => DocTypeLabel === 'TDS');
}
